

exports.__esModule = true;
exports.$LoginRoute = undefined;

require('./directive');

var _squid = require('squid');

var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {

    path: 'login',

    directive: 'xo-login-page',

    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },

    auth: false,

    titleContent: 'base.logIn',

    trackingData: {
        fptiState: 'login',
        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
        templateName: 'login.dust',
        pageGoal: 'Payment Start',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },

    children: []
});

angular.value("$LoginRoute", $LoginRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-login/route.js
 ** module id = 174
 ** module chunks = 1
 **/